import { Link } from 'react-router-dom';
import { User } from 'firebase/auth';
import { doc } from 'firebase/firestore';
import { useFirestore, useFirestoreDocDataOnce } from 'reactfire';

import { IconButton } from '@mui/material';
import ImportExportIcon from '@mui/icons-material/ImportExport';

const BackupLink = ({ currentUser }: { currentUser: User }) => {
  const firestore = useFirestore();

  const { data: userMeta } = useFirestoreDocDataOnce(
    doc(firestore, 'users', currentUser.uid),
  );

  const isAdmin = userMeta.role === 'admin';

  if (!isAdmin) return null;

  return (
    <Link to="/backup">
      <IconButton>
        <ImportExportIcon />
      </IconButton>
    </Link>
  );
};

export default BackupLink;
